import { createAction } from "redux-act";

export const REQUsrActList = createAction("REQUEST_USRACT_LIST");
export const RESUsrActList = createAction("RECEIVE_USRACT_LIST");
export const FailUsrActList = createAction("FAILED_USRACT_LIST");
export const CleanUpUsrActList= createAction("CLEANUP_USRACT_LIST");